import {
  Config,
  ConfigFailure,
  ConfigRepository,
  Either,
  left,
  right,
} from "../../domain";
import { ConfigRemoteDataSourceError } from "../core";
import { ConfigRemoteDataSource } from "../data-sources";

export class ConfigRepositoryImpl implements ConfigRepository {
  constructor(private readonly remoteDataSource: ConfigRemoteDataSource) {}

  private handleError(error: ConfigRemoteDataSourceError): ConfigFailure {
    if (error === "NetworkError") ConfigFailure.networkFailure();
    return ConfigFailure.serverFailure();
  }

  public async edit(config: {
    freeDeliveryMinPrice: number;
    deliveryPrice: number;
    pageSize: number;
  }): Promise<Either<ConfigFailure, null>> {
    try {
      await this.remoteDataSource.edit(config);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async get(): Promise<Either<ConfigFailure, Config>> {
    try {
      const res = await this.remoteDataSource.getConfig();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
